import {useState} from 'react';
import ConfirmDialog from '@/components/ConfirmDialog';
import TextArea from '@/components/TextArea';
import Button from '@/components/Button';
import toast, {ToastType} from '@/components/Toast';
import sdk from '@/sdk';
import {complainSubmit} from '@/sdk/server/utils';
import {KEYS, getData} from '@/store';
import {feLogger, reportDocComplain} from '@/buried';
import classNames from 'classnames';

import styles from './index.module.scss';

interface ComplainDialogProps {
    onCancel: () => void;
    docTitle?: string;
    docGuid?: string;
    docUrl?: string;
    author?: string;
    authorGuid?: string;
    coinCount?: number;
}

function ComplainDialog(props: ComplainDialogProps) {
    const {onCancel} = props;
    const [options, setOptions] = useState([
        {active: false, value: '水文骗币'},
        {active: false, value: '广告及垃圾信息'},
        {active: false, value: '违法违规或涉黄涉暴'},
        {active: false, value: '重复搬运他人内容'},
    ]);
    const [otherReason, setOtherReason] = useState<string>('');
    const [submitting, setSubmitting] = useState(false);
    const [isMaxLength, setIsMaxLength] = useState(false);

    const reportLog = (docGuid: string, reason: string[], coinCount?: number, error?: boolean) => {
        feLogger(reportDocComplain({
            pageId: docGuid || '',
            reason: reason.join(','),
            otherReason: otherReason,
            coinCount: coinCount || 0,
            error: error ? 1 : 0,
        }));
    };

    const submit = () => {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        let {
            author,
            authorGuid,
            docTitle,
            docGuid,
            docUrl,
            coinCount,
        } = props;
        if (!props.docGuid) {
            const curDoc = getData(KEYS.CUR_DOCUMENT);
            coinCount = getData(KEYS.CUR_DOCUMENT_KNOWLEDGE_COIN);
            const {spaceGuid, groupGuid, repositoryGuid, operatorNickname, operatorGuid} = curDoc;
            docGuid = curDoc.docGuid;
            author = operatorNickname;
            authorGuid = operatorGuid;
            docUrl = `${location.origin}/knowledge/${spaceGuid}/${groupGuid}/${repositoryGuid}/${docGuid}`;
            docTitle = curDoc.name || '';
        }
        const reason = options.filter(item => item.active).map(item => item.value);
        const user = sdk.as?.user;
        const params = {
            records: [
                {
                    fields: {
                        '文档标题及链接': {
                            'title': docTitle,
                            'text': docUrl,
                        },
                        '文档ID': docGuid || '',
                        '创作者': author || '',
                        '创作者ID': authorGuid || '',
                        '获币量': coinCount || 0,
                        '疑似作弊原因': reason,
                        '其他原因': otherReason,
                        '投诉人姓名': user?.nickname || '',
                        '投诉人邮箱': user?.email || '',
                        '投诉人ID': user?.userGuid || '',
                        '操作环境': '桌面端',
                    },
                },
            ],
        };
        console.log('投诉----------', params);
        complainSubmit(params).then(res => {
            console.log('投诉---res-------', res);
            setSubmitting(false);
            reportLog(docGuid || '', reason, coinCount, !res);
            if (res) {
                toast({type: ToastType.Success, content: '提交成功', duration: 3000});
                onCancel && onCancel();
            }
        }).catch(err => {
            console.log(err);
            reportLog(docGuid || '', reason, coinCount, true);
            toast({type: ToastType.Error, content: '提交失败，请重试', duration: 3000});
            setSubmitting(false);
        });
    };

    const isSelected = !!options.filter(item => item.active).length;

    return (
        <ConfirmDialog
            headline={'文档投诉'}
            className={styles.complainDialog}
            visible
            confirmLoading={submitting}
            confirmLabel={'提交'}
            confirmDisabled={!isSelected && !otherReason}
            showCloseX
            maskCancel={false}
            onCancel={onCancel}
            onConfirm={submit}
        >
            <div className={styles.complainTypeList}>
                {
                    options.map(item => (
                        <Button
                            key={item.value}
                            className={classNames(styles.complainType, item.active && styles.complainTypeActive)}
                            onClick={() => {
                                item.active = !item.active;
                                setOptions([...options]);
                            }}
                        >{item.value}</Button>
                    ))
                }
            </div>
            <TextArea
                value={otherReason}
                rows={3}
                className={classNames(styles.otherReason, isMaxLength && styles.otherReasonMax)}
                placeholder={'其他（选填）'}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setIsMaxLength(e.target.value.length > 150);
                    setOtherReason(e.target.value.slice(0, 150));
                }}
            />
            <div className={styles.bottomContent}>
                {isMaxLength ? <div className={styles.maxLengthTip}>最多150字</div> : ''}
            </div>
        </ConfirmDialog>
    );
}

export default ComplainDialog;
